import React, {useEffect, useState} from 'react';

const TabbedContents = ({tabContents, hasBorder = true, initialIndex = null}) => {
	const [activeTab, setActiveTab] = useState(0);

	useEffect(() => {
		if (initialIndex !== null && initialIndex <= tabContents.length) {
			setActiveTab(initialIndex);
		}
	}, [initialIndex, tabContents.length]);

	return (
		<div className={`w-full h-full ${hasBorder ? 'rounded-lg border border-borderColor overflow-hidden' : ''}`}>
			<div className="block block-minorHeader max-w-full whitespace-nowrap overflow-x-auto">
				{tabContents && tabContents.map((tab, index) => (
					<button
						key={index}
						className={`tab-item inline-block text-sm py-2 px-4 pb-1 font-semibold lg:text-2xl ${
							activeTab === index
								? 'is-active text-white font-bold border-b-2 border-url'
								: 'text-url'
						}`}
						onClick={() => setActiveTab(index)}
					>
						{tab.label}
					</button>
				))}
			</div>

			<div className={`tab-content ${hasBorder ? 'p-1 lg:p-2' : 'mt-2'}`}>
				{tabContents && tabContents[activeTab].content}
			</div>
		</div>
	);
};

export default TabbedContents;
